var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAccountancy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Accounting-Calculator-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Accounting Calculator 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 15.5a0.25 0.25 0 0 0 -0.25 0.25v8a0.25 0.25 0 0 0 0.25 0.25H18a3 3 0 0 0 3 -3v-5.25a0.25 0.25 0 0 0 -0.25 -0.25ZM15 18h3a0.5 0.5 0 0 1 0 1h-3a0.5 0.5 0 0 1 0 -1Zm0 2h3a0.5 0.5 0 0 1 0 1h-3a0.5 0.5 0 0 1 0 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 15.75a0.25 0.25 0 0 0 -0.25 -0.25h-8a0.25 0.25 0 0 0 -0.25 0.25V21a3 3 0 0 0 3 3h5.25a0.25 0.25 0 0 0 0.25 -0.25Zm-5.85 2.6a0.49 0.49 0 0 1 0.7 -0.7l1 1a0.27 0.27 0 0 0 0.36 0l1 -1a0.49 0.49 0 0 1 0.7 0.7l-1 1a0.27 0.27 0 0 0 0 0.36l1 1a0.48 0.48 0 0 1 0 0.7 0.48 0.48 0 0 1 -0.7 0l-1 -1a0.27 0.27 0 0 0 -0.36 0l-1 1a0.48 0.48 0 0 1 -0.7 0 0.48 0.48 0 0 1 0 -0.7l1 -1a0.27 0.27 0 0 0 0 -0.36Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 5.75a0.76 0.76 0 0 0 0.75 -0.75V3.5a0.75 0.75 0 0 0 -1.5 0V5a0.76 0.76 0 0 0 0.75 0.75Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 0H6a3 3 0 0 0 -3 3v11.25a0.25 0.25 0 0 0 0.25 0.25h8a0.25 0.25 0 0 0 0.25 -0.25v-7.5a0.25 0.25 0 0 0 -0.25 -0.25h-6A0.25 0.25 0 0 1 5 6.25V3a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v3.25a0.25 0.25 0 0 1 -0.25 0.25h-6a0.25 0.25 0 0 0 -0.25 0.25v7.5a0.25 0.25 0 0 0 0.25 0.25h8a0.25 0.25 0 0 0 0.25 -0.25V3a3 3 0 0 0 -3 -3ZM9 11.5h-0.75a0.25 0.25 0 0 0 -0.25 0.25v0.75a0.5 0.5 0 0 1 -1 0v-0.75a0.25 0.25 0 0 0 -0.25 -0.25H6a0.5 0.5 0 0 1 0 -1h0.75a0.25 0.25 0 0 0 0.25 -0.25V9.5a0.5 0.5 0 0 1 1 0v0.75a0.25 0.25 0 0 0 0.25 0.25H9a0.5 0.5 0 0 1 0 1Zm9 0h-3a0.5 0.5 0 0 1 0 -1h3a0.5 0.5 0 0 1 0 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAccountancy);
export default ForwardRef;